export interface UserData {
  accountId: number,
  userId: number,
  name: string,
  email: string,
  phone: string,
  apartmentBlock: string,
  apartmentNumber: number,
  cpf: string,
  rg: string,
  cnpj: string,
  enterprise: string,
  saveId: number | null,
  saveValue: number,
  orderId: number | null,
  orderValue: number,
  contractId: number | null,
  createdAt: number,
  lastLoginDate: number,
}
export interface UserDetailsData extends UserData {
  countryCode,
  zipCode,
  state,
  city,
  neighborhood,
  address,
  addressNumber,
  extendedAddress,
  specialAddress,
  orderItems: any[]
}

export function CurrentUserState(user: UserData) {
  if (user.contractId)
    return (<p className="userState userStateContractSigned">Contrato Assinado</p>);
  else if (user.orderId)
    return (<p className="userState userStateOrdered">Pedido Enviado</p>);
  else if (user.saveId)
    return (<p className="userState userStateSaved">Salvo</p>);
  else
    return (<p className="userState userStateRegister">Cadastrado</p>);
}
